module.exports = __webpack_public_path__ + "static/image/weChat_yz.c2bdc70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/weChat_yz.jpg
// module id = 100
// module chunks = 1